<template>
  <div class="ration-petition__container">
    <div class="ration-petition__title">
      Ration Petition
    </div>
    <div class="ration-petition__subtitle">
      All files are completed upon post-decontamination entry into this facility. All Records are
      made public.
    </div>

    <div
      class="ration-petition__button"
      @click="showPermissionPending"
    >
      REQUEST A RESOURCE
    </div>

    <div class="ration-petition__table">
      <div class="ration-petition__table-header hidden sm:flex">
        <div class="w-16">
          Id
        </div>
        <div class="w-16">
          Date
        </div>
        <div class="w-64">
          Request
        </div>
        <div class="w-64">
          Reason (Optional)
        </div>
        <div class="w-32">
          Approval
        </div>
        <div class="w-64">
          Approval Reasons
        </div>
        <div class="w-64">
          In Stock / Pick Up
        </div>
      </div>
      <div
        v-for="(resource, index) in resources"
        :key="index"
        class="ration-petition__table-row flex-col sm:flex-row"
      >
        <div class="w-full sm:w-16 border-t sm:border-t-0 sm:border-l bg-blue">
          <span class="sm:hidden">Id</span>
          <span>{{ resource.id }}</span>
        </div>
        <div class="w-full sm:w-16">
          <span class="sm:hidden">Date</span>
          <span>{{ resource.date }}</span>
        </div>
        <div class="w-full sm:w-64 bg-blue">
          <span class="sm:hidden">Request</span>
          <span>{{ resource.request }}</span>
        </div>
        <div class="w-full sm:w-64">
          <span class="sm:hidden">Reason</span>
          <span>{{ resource.reason }}</span>
        </div>
        <div class="w-full sm:w-32 text-center bg-blue">
          <span class="sm:hidden">Approval</span>
          <span>{{ resource.approval }}</span>
        </div>
        <div class="w-full sm:w-64">
          <span class="sm:hidden">Reasons</span>
          <span>{{ resource.approvalReason }}</span>
        </div>
        <div class="w-full sm:w-64 text-center bg-blue">
          <span class="sm:hidden">In Stock</span>
          <span>{{ resource.stock }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import resources from '@/services/resourcePetition'

export default {
  name: 'RationsPetition',

  data() {
    return {
      resources,
    }
  },

  methods: {
    ...mapActions({
      showPermissionPending: 'auth/showPermissionPending',
    }),
  },
}
</script>

<style lang="postcss" scoped>
.ration-petition {
  &__button {
    width: 100%;
    height: 34px;
    font-family: 'proxima-nova';
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    @apply bg-blue text-blue-lighter p-2 cursor-pointer mt-8;
  }

  &__container {
    @apply text-blue-light p-4;
  }

  &__title {
    font-family: 'univia-pro';
    font-size: 40px;
    @apply mb-4 uppercase;
  }

  &__subtitle {
    font-family: 'proxima-nova';
    font-size: 20px;
    font-weight: 500;
    @apply mb-4 pb-2 border-b border-blue-light;
  }

  &__table {
    width: 100%;
    @apply mt-8;

    &-header {
      font-family: 'univia-pro';
      font-size: 20px;
      font-weight: 900;
      @apply bg-blue-light text-blue-darkest uppercase;

      & > div {
        @apply p-2;
      }
    }

    &-row {
      font-family: 'proxima-nova';
      font-size: 16px;
      font-weight: 500;
      @apply flex bg-blue-darkest text-blue-lighter mb-4;

      & > div {
        @apply flex justify-between border-l border-b border-r border-blue-lighter p-2 h-8;
      }

      & .selected {
        @apply bg-blue;
      }
    }
  }
}

@screen sm {
  .ration-petition {
    &__button {
      width: 343px;
    }

    &__table {
      width: 1200px;
      @apply pr-4;

      &-row {
        @apply mb-0;
        & > div {
          @apply block border-l-0 h-auto;
        }
      }
    }
  }
}
</style>
